var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_c('a-tooltip',{attrs:{"placement":"top","title":_vm.tips}},[_c('svg-icon',{staticClass:"tooltip-icon",attrs:{"icon-class":'tooltip-icon2'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }